var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9643 10.1271C14.1461 9.95645 14.25 9.71894 14.25 9.47031C14.2389 9.18457 14.1424 8.94707 13.9605 8.81348L10.398 5.57568C10.1346 5.33633 9.75976 5.27695 9.43691 5.42168C9.11406 5.5627 8.90625 5.88184 8.90625 6.20098L8.90625 8.2791L5.64062 8.3125C5.14893 8.3125 4.75 8.71143 4.75 9.20312L4.75 9.79687C4.75 10.2886 5.14893 10.6541 5.64062 10.6541L8.90625 10.6541L8.90625 12.7322C8.90625 13.0859 9.11614 13.4061 9.43988 13.5486C9.76459 13.6901 10.1416 13.6263 10.4014 13.3862L13.9643 10.1271ZM19 9.5C19 4.25273 14.7473 -1.85893e-07 9.5 -4.15258e-07C4.25274 -6.44623e-07 -1.85893e-07 4.25273 -4.15258e-07 9.5C-6.44623e-07 14.7473 4.25273 19 9.5 19C14.7473 19 19 14.7473 19 9.5ZM1.78125 9.5C1.78125 5.24355 5.24393 1.78125 9.5 1.78125C13.7561 1.78125 17.2187 5.24355 17.2187 9.5C17.2187 13.7564 13.7561 17.2187 9.5 17.2187C5.24392 17.2187 1.78125 13.7564 1.78125 9.5Z",
    fill: "#3F6DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.87b35938432c0a893e2560dd7dc76e1d.svg";
export { ForwardRef as ReactComponent };